export const getFieldValidationError = (key, value, orgProfileInfo) => {
  if (key === "companyName" && !value) {
    return "Company Name is required.";
  }

  if (key === "subDomain") {
    if (!value) {
      return "Sub-domain is required.";
    }
    if (!/^\w+(-\w+)*$/.test(value)) {
      return "Invalid sub-domain.";
    }
    if (
      (orgProfileInfo?.restrictDomains || []).some(
        (d) => d.value.toLowerCase() === value.toLowerCase(),
      )
    ) {
      return "Sub domain not available.";
    }
  }

  if (key === "phone" && !value) {
    return "Phone number is required.";
  }

  if (key === "fax" && !value) {
    return "Fax number is required.";
  }

  return "";
};

const getGUIDFromProfileImageURL = (url) => {
  const guid = new URL(url).searchParams.get("guid");
  return guid
}

export const buildOrgProfilePayload = ({
  fieldValues,
  orgProfileInfo,
  selectedTimeZone,
  overrides = {},
}) => ({
  name: fieldValues.companyName ?? orgProfileInfo?.OrganizationName ?? "",
  subdomain:
    fieldValues.subDomain ??
    orgProfileInfo?.Subdomain ??
    orgProfileInfo?.SubDomain ??
    "",
  phone: fieldValues.phone ?? orgProfileInfo?.Phone ?? "",
  fax: fieldValues.fax ?? orgProfileInfo?.Fax ?? "",
  address_line1:
    overrides.addressLine1 ??
    fieldValues.addressLine1 ??
    orgProfileInfo?.Address1 ??
    "",
  address_line2:
    overrides.addressLine2 ??
    fieldValues.addressLine2 ??
    orgProfileInfo?.Address2 ??
    "",
  city: overrides.city ?? fieldValues.city ?? orgProfileInfo?.City ?? "",
  state: overrides.state ?? fieldValues.state ?? orgProfileInfo?.State ?? "",
  country:
    overrides.country ??
    fieldValues.country ??
    orgProfileInfo?.DisplayCountry ??
    "",
  zip: overrides.zip ?? fieldValues.zip ?? orgProfileInfo?.Zip ?? "",
  county:
    overrides.county ?? fieldValues.county ?? orgProfileInfo?.County ?? "",
  profile_image:
    overrides.profileImage !== undefined
      ? overrides.profileImage
      : fieldValues.profileImage ??
        getGUIDFromProfileImageURL(orgProfileInfo?.ProfileFullImage) ??
        "",
  id: orgProfileInfo?.Id ?? orgProfileInfo?.id,
  time_zone_tz:
    overrides.timeZoneTz ??
    selectedTimeZone ??
    orgProfileInfo?.OrgTimeZoneTz ??
    "",
});
